import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { logout } from '../actions/constants'
import { IProductBranch } from '../../models/ivb_product_branch'

export interface IIVBState {
  products: IProductBranch[]
}

const initialState: IIVBState = {
  products: []
}

export const ivbSlice = createSlice({
  name: 'ivb',
  initialState,
  reducers: {
    setIVBConfig: (state, action: PayloadAction<IProductBranch[]>) => {
      state.products = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState)
  }
})

export const { setIVBConfig } = ivbSlice.actions

export default ivbSlice.reducer
